import {
  SET_HOME_SERVICES_OFFERS,
  SET_HOME_SERVICES_PROPERTY_CONFIG,
} from './home-services.actions';
import { isNewMove } from './home-services.epic';

export function HomeServicesReducer(state = {}, action) {
  if (action.type === SET_HOME_SERVICES_OFFERS) {
    return {
      ...state,
      searchHomeServicesOffers: action.payload,
    };
  }

  if (action.type === SET_HOME_SERVICES_PROPERTY_CONFIG) {
    return {
      ...state,
      propertyConfig: action.payload || {},
    };
  }

  if (isNewMove(action)) {
    const { searchHomeServicesOffers, ...otherState } = state;
    return otherState;
  }

  return state;
}
